<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>门诊预约问诊管理</el-breadcrumb-item>
        <el-breadcrumb-item>专家问诊管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="container">
      <div class="search">
        <div>医生查询：</div>
        <el-select style="width: 400px" filterable remote v-model="doctorId" :remote-method="remoteMethod" placeholder="请搜索并选择医生" @change="onDoctorChange">
          <el-option v-for="(item, index) in doctorList" :key="index" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </div>

      <div class="im-container box-shadow">
        <div class="side-bar">
          <div class="patient" :class="patientName === item.account ? 'patient-active' : ''" v-for="(item, index) in patientList" :key="index" @click="loadChatMessage(item)">
            <div class="name">{{ item.account }}</div>
          </div>
        </div>
        <div class="im-box">
          <div class="message-container" @scroll="scrollEvent" ref="container">
            <div v-for="item in messageList" :key="item.id" class="container">
              <div class="message-box" v-if="item.senderType === 1">
                <div class="portrait">
                  <span>{{ patientName }}</span>
                </div>
                <div class="message-content mgl10">
                  <div class="content" v-if="item.messageType === 1">
                    {{ item.commentText }}
                  </div>
                  <div v-if="item.messageType === 2">
                    <el-image class="picture" :src="item.picUrl" :preview-src-list="[item.picUrl]"> </el-image>
                  </div>
                  <div class="create-time">
                    {{ item.createdTime | formatDate(true) }}
                  </div>
                </div>
              </div>
              <div class="message-box reverse" v-else>
                <div class="message-content flex-right mgr10">
                  <div class="content flex-end" v-if="item.messageType === 1">
                    {{ item.commentText }}
                  </div>
                  <div v-if="item.messageType === 2">
                    <el-image class="picture" :src="item.picUrl" :preview-src-list="[item.picUrl]"> </el-image>
                  </div>
                  <div class="create-time flex-end">
                    {{ item.createdTime | formatDate(true) }}
                  </div>
                </div>
                <div class="portrait">
                  <span>我</span>
                </div>
              </div>
            </div>
          </div>
          <div class="message-sender">
            <div class="tool-bar">
              <el-upload v-show="patientName" class="upload" :before-upload="handleBeforeUpload" :show-file-list="false" :limit="1" action="https://fwj-app.servicesplus.cn/upload/">
                <el-button size="small" type="primary">上传图片</el-button>
              </el-upload>
            </div>
            <div class="sender">
              <el-input
                :disabled="!patientName"
                @keyup.enter.native="sendMessage(message, 1)"
                v-model="message"
                class="input"
                type="textarea"
                :rows="4"
                resize="none"
                placeholder="请输入您要咨询的问题"
              ></el-input>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  data() {
    return {
      doctorId: "",
      doctorList: [],
      patientList: [],
      messageList: [],
      patientName: "",
      message: "",
      medicalUserId: "",
      patientRow: {},
    };
  },

  mounted() {
    this.loadDoctorList("");
  },

  methods: {
    scrollEvent() {},
    /**
     * @description: 加载医生列表
     * @param {*} name
     * @return {*}
     */
    loadDoctorList(name) {
      this.$http({
        url: global.apiUrl + "/medical/doctor/list",
        method: "GET",
        params: {
          name,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.doctorList = res.body.data.dataList;
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * @description: 远程查询
     * @param {*} name
     * @return {*}
     */
    remoteMethod(name) {
      this.loadDoctorList(name);
    },
    /**
     * @description: 医生选择事件
     * @param {*} doctorId
     * @return {*}
     */
    onDoctorChange(doctorId) {
      this.$http({
        url: global.apiUrl + "/medical/doctor/online/users",
        method: "GET",
        params: {
          doctorId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.patientList = res.body.data;
            this.messageList = [];
            this.message = "";
            this.patientName = "";
            if (this.patientList.length > 0) {
              this.patientName = this.patientList[0].account;
              this.loadChatMessage(this.patientList[0]);
            }
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * @description: 加载聊天信息
     * @param {*} row
     * @return {*}
     */
    loadChatMessage(row) {
      this.patientRow = row;
      this.medicalUserId = row.id;
      this.patientName = row.account;
      this.$http({
        url: global.apiUrl + "/medical/consultation/list",
        method: "GET",
        params: {
          doctorId: this.doctorId,
          medicalUserId: row.id,
          pageIndex: 1,
          pageSize: 100,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.messageList = res.body.data.dataList;
            setTimeout(() => {
              const ele = this.$refs.container;
              ele.scrollTop = ele.scrollHeight;
            }, 800);
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * @description:
     * @param {*}
     * @return {*}
     */
    handleBeforeUpload(file) {
      const params = new FormData();
      params.append("file", file);
      params.append("path", "upload/ad-img");
      Vue.ajaxPost(this, global.apiImageUpload + "/oss/image/upload", params, { "Content-Type": "multipart/form-data" })
        .then(res => {
          this.uploading = false;
          this.sendMessage(res.data.data, 2);
        })
        .finally(() => {
          this.uploading = false;
        });
    },
    /**
     * @description: 发送消息
     * @param {*} message
     * @param {*} messageType
     * @return {*}
     */
    sendMessage(message, messageType) {
      let picUrl = "";
      let commentText = "";
      if (messageType > 1) {
        picUrl = message;
      } else {
        commentText = message;
      }
      const bodyParams = Object.assign(
        {},
        {
          doctorId: this.doctorId,
          userAccountId: 20158,
          medicalUserId: this.medicalUserId,
          commentText,
          picUrl,
          messageType,
          senderType: 2,
        }
      );
      this.$http({
        url: global.apiUrl + "/medical/consultation/add",
        method: "POST",
        body: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.loadChatMessage(this.patientRow);
            if (messageType === 1) {
              this.message = "";
            }
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  .search {
    display: flex;
    align-items: center;
    margin: auto;
    width: fit-content;
  }
  .im-container {
    max-width: 1000px;
    margin: 20px auto;
    border-radius: 10px;
    height: 600px;
    display: flex;
    .side-bar {
      width: 200px;
      height: 100%;
      border-right: 1px #e8e8e8 solid;
      background: #fff;
      .patient {
        border-bottom: 1px #e8e8e8 solid;
        font-size: 24px;
        padding: 10px;
        cursor: pointer;
        text-align: center;
      }
      .patient-active {
        background: #008080;
        color: #fff;
        font-weight: 700;
      }
    }
    .im-box {
      width: 800px;
      height: 100%;
      background: #fff;
      position: relative;
      .message-container {
        width: 100%;
        height: calc(100% - 140px);
        overflow: scroll;
        .container {
          width: 100%;
          display: table;
          .message-box {
            padding: 10px 20px;
            display: flex;
            .portrait {
              img {
                width: 40px;
                height: 40px;
                border-radius: 5px;
              }
              span {
                border-radius: 5px;
                background: #008080;
                color: #fff;
                font-size: 24px;
                line-height: 40px;
                text-align: center;
                padding: 5px 10px;
              }
            }
            .message-content {
              .content {
                padding: 10px 20px;
                background: #008080;
                color: #fff;
                font-size: 14px;
                border-radius: 5px;
                width: fit-content;
              }
              .picture {
                cursor: pointer;
                max-width: 120px;
                max-height: 160px;
                border-radius: 5px;
              }
              .create-time {
                margin-top: 10px;
                font-size: 12px;
                color: #e8e8e823;
              }
            }
          }
          .mgl10 {
            margin-left: 10px;
          }
          .mgr10 {
            margin-right: 10px;
          }
          .reverse {
            float: right;
          }
          .flex-right {
            display: flex;
            flex-direction: column;
            .flex-end {
              align-self: flex-end;
            }
          }
        }
      }

      .message-sender {
        width: 100%;
        height: 140px;
        position: absolute;
        border-top: 1px #e8e8e8 solid;
        bottom: 0;
        left: 0;
        .tool-bar {
          width: 100%;
          height: 40px;
          .upload {
            margin-top: 6px;
            margin-left: 5px;
          }
        }
        .sender {
          width: 100%;
          height: 100px;
          .input {
            border: none;
          }
        }
      }
    }
  }
}
</style>
